import { message } from '@/components/Message';
import NumericKeyboard from '@/components/NumericKeyboard';
import PosButton from '@/components/PosButton';
import { UserInfo } from '@/components/User/UserInfo';
import { BaseInfoContext } from '@/context/BaseInfoContext';
import { UserFullInfo } from '@/models/user';
import { playSound } from '@/utils/sound';
import { UserOutlined } from '@ant-design/icons';
import { Flex, PopoverProps } from 'antd';
import React, { useContext, useMemo } from 'react';
import { fastActionBtnProps } from '../utils/ui';

export type BindUserProps = {
  // onBind: UserModalProps['onBind'];
  // onUnbind: UserModalProps['onUnbind'];
  // onRecharge: UserModalProps['onRecharge'];
  // isGlobal: boolean;
  userFullInfo?: UserFullInfo;
  renderButton?: (userFullInfo: UserFullInfo) => React.ReactElement;
  popoverPlacement?: PopoverProps['placement'];
};

const BindUser: React.FC<BindUserProps> = ({
  // onBind,
  // onUnbind,
  // onRecharge,
  // isGlobal,
  renderButton,
  userFullInfo,
  popoverPlacement = 'topLeft',
}: BindUserProps) => {
  const [, , helpers] = useContext(BaseInfoContext);

  const customButton = useMemo(() => {
    if (renderButton) {
      return (
        <span
          onClick={() => {
            helpers.showUserModal({
              userFullInfo,
            });
          }}>
          {renderButton(userFullInfo)}
        </span>
      );
    }
  }, [renderButton, userFullInfo]);

  return (
    <>
      {userFullInfo &&
        (customButton ? (
          customButton
        ) : (
          <PosButton
            {...fastActionBtnProps}
            onClick={() => {
              helpers.showUserModal({
                userFullInfo,
              });
            }}>
            <UserInfo user={userFullInfo.user}>
              {({ Field }) => {
                return (
                  <Flex>
                    <Field type="avatar" avatarProps={{ size: 32 }} />
                    <Field type="name" />
                  </Flex>
                );
              }}
            </UserInfo>
          </PosButton>
        ))}
      {!userFullInfo && (
        <NumericKeyboard
          trigger={'click'}
          placement={popoverPlacement}
          placeholder={'输入手机号查找客户'}
          closeOnScanReceived
          onComplete={num => {
            let code = `${num}`;
            if (num) {
              if (code.length >= 4) {
                helpers.showUserModal({
                  userMobile: code,
                });
              } else {
                message.error('请至少输入4位手机号');
                playSound('error');
              }
            }
          }}>
          {customButton ? (
            customButton
          ) : (
            <PosButton {...fastActionBtnProps} onClick={() => {}} icon={<UserOutlined />}>
              客户
            </PosButton>
          )}
        </NumericKeyboard>
      )}
    </>
  );
};

export default BindUser;
